import { debug, info, warn, error, fatal } from './actions';
export const logging = (dispatch, namespace) => {
  const log = (action, fields, msg) => {
    if (typeof fields === 'string') {
      dispatch(action({
        namespace
      }, fields));
    } else {
      dispatch(action({
        ...fields,
        namespace
      }, msg || ''));
    }
  };
  return {
    debug: (...args) => log(debug, ...args),
    info: (...args) => log(info, ...args),
    warn: (...args) => log(warn, ...args),
    error: (...args) => log(error, ...args),
    fatal: (...args) => log(fatal, ...args)
  };
};